export const FACT_CHART_REQUEST = 'FACT_CHART_REQUEST';
export const FACT_CHART_SUCCESS = 'FACT_CHART_SUCCESS';
export const FACT_CHART_FAILURE = 'FACT_CHART_FAILURE';
export const FACT_CHART_MODAL_OPEN = 'FACT_CHART_MODAL_OPEN';
export const FACT_CHART_MODAL_CLOSE = 'FACT_CHART_MODAL_CLOSE';



// WEBPACK FOOTER //
// ./webpack/assets/javascripts/react_app/components/FactCharts/FactChartConstants.js